module.exports = __webpack_public_path__ + "img/5.ca2d92c.png";